import { put, takeLatest } from "redux-saga/effects";
import { getPopularFareDataFailure, getPopularFareDataSuccess, popularFareDataRequest, requestedAirportDataFailure, requestedAirportDataRequest, requestedAirportDataSuccess } from "../slice/popularFareSlice";
import { config } from "../../../config/global";
import api from "../../../config/api";
const URL = config.POPULAR_FARE;
const AIRPORT_URL = config.POPULARFARE_REQUESTED_AIRPORTS;
function* getPopularFareData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield api.post(URL, payload);
    yield put(getPopularFareDataSuccess(response.data));
  } catch (error) {
    yield put(getPopularFareDataFailure(error.message));
  }
}
function* requestedAirportsData() {
  try {
    const response = yield api.get(AIRPORT_URL);
    yield put(requestedAirportDataSuccess(response.data));
  } catch (error) {
    yield put(requestedAirportDataFailure(error.message));
  }
}
export function* watchPopularFareSaga() {
  yield takeLatest(popularFareDataRequest, getPopularFareData);
}
export function* watchRequestedAirportsDataSaga() {
  yield takeLatest(requestedAirportDataRequest, requestedAirportsData);
}